

































import { Component, Vue, Inject } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import AddDevice from "./device/add-device.vue";
import PageRequest from "@/store/entities/page-request";
class PageDeviceRequest extends PageRequest {
  keyword: string = "";
  officeId: number = null;
}

@Component({ components: { AddDevice } })
export default class Device extends AbpBase {
  pagerequest: PageDeviceRequest = new PageDeviceRequest();
  addDeviceModal: boolean = false;
  offices: Array<any> = [];

  get list(){
    return this.$store.state.device.list;
  }
  get pageSize() {
    return this.$store.state.device.pageSize;
  }
  get totalCount() {
    return this.$store.state.device.totalCount;
  }
  get currentPage() {
    return this.$store.state.device.currentPage;
  }
  pageChange(page: number) {
    this.$store.commit("device/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("device/setPageSize", pagesize);
    this.getpage();
  }

  async getpage(){
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters

    await this.$store.dispatch({
      type: "device/getAll",
      data: this.pagerequest,
    });
  }

  async getOffices(){
    this.offices = await this.$store.dispatch({
      type: "office/getMyOffices"
    })
  }

  create() {
    (this.$refs.addDeviceForm as any).init(this.offices);
    this.addDeviceModal = true;
  }

  async created() {
    this.getpage();
    this.getOffices();
  }


  columns = [
    {
      title: this.L("Name"),
      key: "name",
    },
    {
      title: this.L("DeviceCount"),
      key: "count",
    },
    {
      title: this.L("Room"),
      key: "meetingRoom",
    },
    {
      title: this.L("Remark"),
      key: "remark",
    },
    {
      title: this.L("DeviceState"),
      key: "state",
    }
  ];
}
